// SubscriptionPaymentMethodStatus is an object representing the status of payment method
const SubscriptionPaymentMethodStatus = {
  Initiated: "initiated",
  Active: "active",
  NonRecurrent: "non_recurrent",
  Failed: "failed",
};

Object.freeze(SubscriptionPaymentMethodStatus);

export default SubscriptionPaymentMethodStatus;
